import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: "AIzaSyC1nJvy-k7dgsciKybZZ2cWHZJMhSCp048",
  authDomain: "thedojosite-c7979.firebaseapp.com",
  projectId: "thedojosite-c7979",
  storageBucket: "thedojosite-c7979.appspot.com",
  messagingSenderId: "963344452921",
  appId: "1:963344452921:web:44b6e92a79ae0ee3342ce8"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()

// timestamp
const timestamp = firebase.firestore.Timestamp

export { projectFirestore, projectAuth, timestamp, projectStorage }